<app-toast></app-toast>
<div [ngClass]="{'bg-advventure': shouldUseFieldset()}">
  <app-nav *ngIf="isLoggedIn"></app-nav>

  <ng-container *ngIf="shouldUseFieldset(); else noFieldsetTemplate">

    <p-fieldset>
      <ng-template class="flex" pTemplate="header">
        <div class="flex grid col-12 p-0 m-0">
          <div class="flex align-items-center col-6 p-0 m-0">
            <ng-container *ngIf="isIconImage(); else primeIconTemplate">
              <img [src]="icone" alt="Ícone" style="width: 20px; height: 20px;" />
            </ng-container>
            <ng-template #primeIconTemplate>
              <i [ngClass]="icone"></i>
            </ng-template>
            <div class="ml-2">
              {{ titulo }}
            </div>
          </div>
          <div class="flex justify-content-end col-6 align-items-center p-0 m-0">
            <p-chip *ngIf="mostrarDescricao" class="ml-8" [ngClass]="{'chipDescricao': true}" (click)="showDialog()"
              [label]="'Como funciona ' + tituloDescricao + '?'">
            </p-chip>
          </div>
        </div>
      </ng-template>
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </p-fieldset>

  </ng-container>


  <ng-template #noFieldsetTemplate>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </ng-template>
  <p-scrollTop />
</div>


<p-dialog [header]="tituloDescricao" [modal]="true" [(visible)]="visible" [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">
  <p [innerHTML]="textoDescricao" class="pulaLinha">
    {{textoDescricao}}
  </p>
</p-dialog>